import React from 'react';
import { Card } from 'Components/Common/Card/Card';

export const FSEReceptor = ({ receptor, codigoGeneracion }) => {
  return (
    <Card header={`Sujeto Excluido (${codigoGeneracion})`}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <div>
          <strong>Tipo Documento:</strong> {receptor.tipoDocumento}
        </div>
        <div>
          <strong>Número Documento:</strong> {receptor.numDocumento}
        </div>
        <div>
          <strong>Nombre:</strong> {receptor.nombre}
        </div>
        {receptor.telefono && (
          <div>
            <strong>Teléfono:</strong> {receptor.telefono}
          </div>
        )}
        {receptor.correo && (
          <div>
            <strong>Correo:</strong> {receptor.correo}
          </div>
        )}
      </div>
    </Card>
  );
};
